export default __webpack_public_path__ + "static/media/misc-pantry1-768w.4aac11ea.png";